import { getIntl } from "context/SettingsProvider";
import technicianSettings from "helpers/technicianSettings";
import * as yup from "yup";

export const CreateJobValidationSchema = () => {
  const intl = getIntl();

  return yup.object({
    customer: yup
      .object()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "createJob.customerRequired" }),
        test: (value) => {
          return !!value?.id;
        },
      }),
    symptomCode1: yup
      .string()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "visit.symptomRequired" }),
        test: (value) => {
          return technicianSettings.requireSymptomCode1 ? !!value : true;
        },
      }),
    symptomCode2: yup
      .string()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "visit.symptomRequired" }),
        test: (value) => {
          return technicianSettings.requireSymptomCode2 ? !!value : true;
        },
      }),
    symptomCode3: yup
      .string()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "visit.symptomRequired" }),
        test: (value) => {
          return technicianSettings.requireSymptomCode3 ? !!value : true;
        },
      }),
    description: yup.string().test({
      name: "required",
      message: intl.formatMessage({ id: "createJob.descriptionRequired" }),
      test: (value) => {
        return technicianSettings.requireSymtomText ? !!value : true;
      },
    }),
    machine: yup.object().nullable(),
  });
};
